/* tslint:disable */
import {
  Apptype,
  App
} from '../index';

declare var Object: any;
export interface MetadataInterface {
  custom: boolean;
  name: string;
  label: string;
  plural_label: string;
  description: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  apptypeId?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  apptype?: Apptype;
  app?: App;
}

export class Metadata implements MetadataInterface {
  custom: boolean;
  name: string;
  label: string;
  plural_label: string;
  description: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  apptypeId: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  apptype: Apptype;
  app: App;
  constructor(data?: MetadataInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Metadata`.
   */
  public static getModelName() {
    return "Metadata";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Metadata for dynamic purposes.
  **/
  public static factory(data: MetadataInterface): Metadata{
    return new Metadata(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Metadata',
      plural: 'metadata',
      properties: {
        custom: {
          name: 'custom',
          type: 'boolean',
          default: false
        },
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        plural_label: {
          name: 'plural_label',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Metadata.ts